module.exports = __webpack_public_path__ + "img/copywriting2.91399dee.jpg";